module.exports = __webpack_public_path__ + "img/eyebrow_male_arched_average.363d9085.png";